﻿import {AttachmentResult} from "../types/AttachmentResult";

export function createAttachmentHref(attachment: AttachmentResult, linkPrefix: string): string {
	return `${linkPrefix}/${encodeURIComponent(attachment.blobId)}`
}
